<div class="opportunities-container">
  <!-- Header -->
  <div class="opportunities-header">
    <div class="header-content">
      <h3><i class="fas fa-handshake"></i> Sales Opportunities</h3>
      <div class="header-stats">
        <div class="stat-item">
          <span class="stat-label">Total Value</span>
          <span class="stat-value">${{ getTotalValue() | number:'1.2-2' }}</span>
        </div>
        <div class="stat-item">
          <span class="stat-label">Open Value</span>
          <span class="stat-value">${{ getOpenValue() | number:'1.2-2' }}</span>
        </div>
        <div class="stat-item">
          <span class="stat-label">Won Value</span>
          <span class="stat-value">${{ getWonValue() | number:'1.2-2' }}</span>
        </div>
      </div>
    </div>
    <button class="btn btn-primary" (click)="showCreateForm = !showCreateForm">
      <i class="fas fa-plus"></i> {{ showCreateForm ? 'Cancel' : 'New Opportunity' }}
    </button>
  </div>

  <!-- Create Opportunity Form -->
  <div class="create-form" *ngIf="showCreateForm">
    <div class="form-header">
      <h4><i class="fas fa-plus-circle"></i> Create New Opportunity</h4>
    </div>
    <div class="form-content">
      <div class="form-row">
        <div class="form-group">
          <label for="title">Opportunity Title</label>
          <input type="text" id="title" [(ngModel)]="newOpportunity.title" class="form-input" placeholder="Enter opportunity title">
        </div>
        <div class="form-group">
          <label for="value">Value ($)</label>
          <input type="number" id="value" [(ngModel)]="newOpportunity.value" class="form-input" placeholder="0.00" step="0.01">
        </div>
      </div>
      <div class="form-row">
        <div class="form-group">
          <label for="stage">Initial Stage</label>
          <select id="stage" [(ngModel)]="newOpportunity.stage_id" class="form-select">
            <option value="0">Select Stage</option>
            <option *ngFor="let stage of opportunityStages" [value]="stage.id">
              {{ stage.name }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label for="closeDate">Expected Close Date</label>
          <input type="date" id="closeDate" [(ngModel)]="newOpportunity.expected_close_date" class="form-input">
        </div>
      </div>
      <div class="form-group">
        <label for="description">Description</label>
        <textarea id="description" [(ngModel)]="newOpportunity.description" class="form-textarea" rows="3" placeholder="Enter opportunity description"></textarea>
      </div>
      <div class="form-actions">
        <button class="btn btn-secondary" (click)="showCreateForm = false; resetForm()">
          <i class="fas fa-times"></i> Cancel
        </button>
        <button class="btn btn-success" (click)="createOpportunity()" [disabled]="!newOpportunity.title || !newOpportunity.stage_id">
          <i class="fas fa-save"></i> Create Opportunity
        </button>
      </div>
    </div>
  </div>

  <!-- Opportunities List -->
  <div class="opportunities-list" *ngIf="!loading">
    <div class="opportunity-card" *ngFor="let opportunity of opportunities">
      <div class="card-header">
        <div class="opportunity-title">
          <h4>{{ opportunity.title }}</h4>
          <div class="opportunity-value">${{ opportunity.value | number:'1.2-2' }}</div>
        </div>
        <div class="card-actions">
          <button class="btn-icon" (click)="deleteOpportunity(opportunity)" title="Delete">
            <i class="fas fa-trash"></i>
          </button>
        </div>
      </div>

      <div class="card-content">
        <div class="opportunity-info">
          <div class="info-item">
            <label>Stage</label>
            <div class="stage-selector">
              <select [(ngModel)]="opportunity.stage_id" (change)="updateOpportunityStage(opportunity, opportunity.stage_id)" class="stage-select">
                <option *ngFor="let stage of opportunityStages" [value]="stage.id">
                  {{ stage.name }}
                </option>
              </select>
              <div class="stage-indicator" [style.background-color]="getStageColor(opportunity.stage_id)"></div>
            </div>
          </div>
          <div class="info-item">
            <label>Expected Close</label>
            <div class="date-display">
              <i class="fas fa-calendar"></i>
              {{ opportunity.expected_close_date | date:'MMM dd, yyyy' }}
            </div>
          </div>
          <div class="info-item" *ngIf="opportunity.lost_reason_name">
            <label>Lost Reason</label>
            <div class="lost-reason">{{ opportunity.lost_reason_name }}</div>
          </div>
        </div>

        <div class="opportunity-description" *ngIf="opportunity.description">
          <p>{{ opportunity.description }}</p>
        </div>

        <div class="opportunity-meta">
          <div class="meta-item">
            <i class="fas fa-clock"></i>
            <span>Created {{ opportunity.created_at | date:'MMM dd, yyyy' }}</span>
          </div>
          <div class="meta-item" *ngIf="opportunity.updated_at !== opportunity.created_at">
            <i class="fas fa-edit"></i>
            <span>Updated {{ opportunity.updated_at | date:'MMM dd, yyyy' }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="empty-state" *ngIf="opportunities.length === 0">
      <div class="empty-icon">
        <i class="fas fa-handshake"></i>
      </div>
      <h4>No Opportunities Yet</h4>
      <p>Start tracking sales opportunities for this customer.</p>
      <button class="btn btn-primary" (click)="showCreateForm = true">
        <i class="fas fa-plus"></i> Create First Opportunity
      </button>
    </div>
  </div>

  <!-- Loading State -->
  <div class="loading-state" *ngIf="loading">
    <div class="spinner"></div>
    <p>Loading opportunities...</p>
  </div>
</div>









